/* eslint-disable max-len */
import React from 'react';

interface IWorldProps {
    width?: number;
    height?: number;
}

const World: React.FC<IWorldProps> = ({width = 47, height = 14}) => {

    return (
        <svg width={width} height={height} viewBox="0 0 47 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.95" d="M33.2207 6.66309V14.0003H37.4117V9.8731H41.6295C43.8325 9.8731 45.7131 8.5404 46.4384 6.66309H33.2207Z" fill="#899696"/>
            <path d="M33.0332 0C33.0466 0.37259 33.1004 0.74518 33.181 1.08912C33.1944 1.16077 33.2212 1.24675 33.2347 1.3184C33.2481 1.34707 33.2481 1.37573 33.2615 1.41872C34.0138 3.95521 36.2302 5.78952 38.8495 5.78952H46.5867C46.6405 5.50291 46.6673 5.2163 46.6673 4.91536C46.6673 3.48231 46.0897 2.19256 45.1629 1.28974C44.3435 0.48724 43.2554 0 42.0465 0H33.0332Z" fill="url(#paint0_linear_14967_273376)"/>
            <path opacity="0.95" d="M25.6984 1.47604L22.7701 8.2544H22.4746V0H18.3105V13.9722H21.8432C22.7701 13.9722 23.6164 13.399 24.0059 12.4962L26.9342 5.71786H27.2297V13.9722H31.3939V0H27.8611C26.9342 0 26.088 0.57322 25.6984 1.47604Z" fill="#899696"/>
            <path opacity="0.95" d="M6.44767 1.8343L8.19391 8.2544H8.48943L10.2222 1.8343C10.5178 0.74519 11.4446 0 12.5058 0H16.6699V13.9722H12.5058V5.71786H12.2103L9.81926 13.9722H6.85065L4.45964 5.71786H4.16412V13.9722H0V0H4.16412C5.2253 0 6.15215 0.74519 6.44767 1.8343Z" fill="#899696"/>
            <defs>
                <linearGradient id="paint0_linear_14967_273376" x1="27.4995" y1="2.89652" x2="42.9995" y2="2.89652" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#9EA8A8" stopOpacity="0.3"/>
                    <stop offset="1" stopColor="#9EA8A8"/>
                </linearGradient>
            </defs>
        </svg>
    );
};

export default World;